import compliance from 'data/compliance.json'

/**
 * Walks the compliance configuration and collects every value that is still
 * marked `"confirmed": false`, so that unverified business facts can be listed
 * for the website owner instead of being published as if they were checked.
 */
export const itemsAwaitingConfirmation = (node = compliance, path = []) => {
  if (!node || typeof node !== 'object') {
    return []
  }

  if (!Array.isArray(node) && node.confirmed === false) {
    return [{ path: path.join(' › '), note: node.note || '' }]
  }

  return Object.entries(node).reduce((found, [key, value]) => (
    found.concat(itemsAwaitingConfirmation(value, path.concat(key)))
  ), [])
}

export const isAwaitingConfirmation = compliance.meta.pendingBusinessConfirmation

export default compliance
